// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__1sBVm","content":"styles_content__3epgX","checkbox":"styles_checkbox__3XsLj","checkboxLabel":"styles_checkboxLabel__Hc2JP"};